import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    title: 'Guía de Juegos Rápidos para Clases de Emergencia',
    desc: 'Actividades que podés aplicar cuando necesitás improvisar una clase rápidamente.',
    img: 'https://cdn.magicpatterns.com/uploads/daZk6Cr1WwNzg8bCz3Cf8H/bono_1.png'
  }, {
    title: 'Manual de Evaluaciones Físicas',
    desc: 'Instrumentos simples para evaluar desempeño físico de los alumnos.',
    img: 'https://cdn.magicpatterns.com/uploads/nTd3oYn3NTFUuqvnhUmNru/bono_2.png'
  }, {
    title: 'Banco de Juegos Cooperativos',
    desc: 'Actividades que fomentan trabajo en equipo y participación.',
    img: 'https://cdn.magicpatterns.com/uploads/3NpYhKtd9rcmE2siPQ4GDy/bono_3.png'
  }, {
    title: 'Guía de Actividades para Espacios Reducidos',
    desc: 'Soluciones cuando el patio o gimnasio es pequeño.',
    img: 'https://cdn.magicpatterns.com/uploads/eAavdGDwKT6TkE74KtW7RF/bono_4.png'
  }];
  return <section className="py-20 bg-[#0C2818]" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="text-center mb-16" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-32">
            Además recibís bonos estratégicos incluidos sin costo adicional
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-33">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#1B4332] p-6 rounded-2xl border border-[#1E4D2B] flex flex-col sm:flex-row gap-6 items-start relative overflow-hidden group hover:border-[#FBBF24]/50 transition-colors" data-id="element-34">
              <div className="absolute top-0 right-0 bg-[#F97316] text-white text-[10px] font-black px-3 py-1 rounded-bl-lg uppercase tracking-wider z-10" data-id="element-35">
                GRATIS
              </div>

              <div className="flex-shrink-0 w-24 h-32 bg-[#143524] rounded-lg flex items-center justify-center border border-[#1E4D2B] shadow-inner overflow-hidden" data-id="element-36">
                <img src={bonus.img} alt={bonus.title} loading="lazy" width={96} height={128} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-37" />
              </div>

              <div className="flex-1 pt-2" data-id="element-38">
                <h3 className="text-[#FBBF24] font-bold text-lg mb-2 leading-tight pr-8" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-40">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}